import { Box, Typography, List, Grid, Paper, Avatar, Chip } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../../../../hooks/store-hooks";
import { unselectListaCbo } from "../../../../../../../../application/states/geo-veles/lista-cbo";
import { removeListaCBOFilterState } from "../../../../../../../../application/states/geo-veles";

export const PreviaFiltroListaCbo = () => {
  const selectedListas = useAppSelector((state) => state.listaCbo.selectedListasCbo);
  const dispatch = useAppDispatch();

  const handleRemove = (lista: any) => {
    dispatch(unselectListaCbo({ lista }));
    dispatch(removeListaCBOFilterState({ idVelesGeoListaCBO: lista.IdVelesGeoListaCBO }));
  };

  if (selectedListas.length === 0) {
    return (
      <Box textAlign="center" py={4}>
        <Typography variant="body1" color="textSecondary">
          Nenhuma lista selecionada.
        </Typography>
      </Box>
    );
  }

  return (
    <List>
      <Paper elevation={2} sx={{ my: 2, p: 2 }}>
        <Box mb={1}>
          <Typography variant="h6" color="primary" fontWeight="bold">
            Incluir
          </Typography>
        </Box>

        <Box my={3}>
          <Typography color="primary" fontWeight="bold">
            Listas de CBO selecionadas:
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {selectedListas.map((lista) => (
            <Grid item key={lista.IdVelesGeoListaCBO} marginBottom={2}>
              <Chip
                sx={{
                  height: 'auto',
                  '& .MuiChip-label': {
                    transition: '0.1s all',
                    display: 'block',
                    whiteSpace: 'normal',
                    padding: '10px 15px',
                    fontWeight: 'bold',
                  },
                }}
                color="primary"
                onDelete={() => handleRemove(lista)}
                avatar={
                  <Avatar sx={{
                    "&": {
                      transition: '0.1s all'
                    },
                    "&:hover": {
                      color: "secondary.main",
                      cursor: 'default'
                    }
                  }}>
                  </Avatar>
                }
                label={`${lista.Nome.toUpperCase()} (${Array.isArray(lista.CBOs) ? lista.CBOs.length : 0} ocupações)`}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </List>
  );
};